module.exports = __webpack_public_path__ + "static/media/urban-farming-desktop.b65c3248.jpg";